export default __webpack_public_path__ + "static/media/mypic.447553a2.jpeg";